import RejectLessonContainer from './container';

export default RejectLessonContainer;
